import {serialize} from '@/utils/util'
import {getStore} from '@/utils/store'
import NProgress from 'nprogress' // progress bar
import router from "@/router/index"
import {Message} from 'element-ui'
import 'nprogress/nprogress.css'
import store from "@/store"; // progress bar style
import axios from 'axios';
import { getToken, removeToken } from './cookies.js'
import Cookies from "js-cookie";
axios.defaults.timeout = 60000
axios.defaults.baseURL = process.env.VUE_APP_URL
// axios.defaults.baseURL = '/api'
console.log('NODE_ENV=='+process.env.NODE_ENV)
console.log('VUE_APP_URL=='+process.env.VUE_APP_URL)
// 返回其他状态码
axios.defaults.validateStatus = function (status) {
    return status >= 200 && status <= 500 // 默认的
}
// 跨域请求，允许保存cookie
axios.defaults.withCredentials = true
// NProgress Configuration
NProgress.configure({
    showSpinner: true
})

function isEmpty(object) {
    for (var name in object) {
        return false;
    }
    return true;
}

function deleteEmptyProperty(object){
    for (var i in object) {
        var value = object[i];
        if (typeof value === 'object') {
            if (Array.isArray(value)) {
                if (value.length == 0) {
                    delete object[i];
                    continue;
                }
            }
            deleteEmptyProperty(value);
            if (isEmpty(value)) {
                delete object[i];
            }
        } else {
            if (value === '' || value === null || value === undefined) {
                delete object[i];
            } else {
            }
        }
    }
}


// HTTPrequest拦截
axios.interceptors.request.use(config => {
    NProgress.start() // start progress bar
    const isToken = (config.headers || {}).isToken === false
    let token =  getToken()
    // console.log('token==',token)
    // console.log('isToken==',isToken)
    let tenantId = Cookies.get('tenant_id')
    if (tenantId) {
        config.headers['Tenant-Id'] = Cookies.get('tenant_id')
        config.headers['Authorization'] = 'Basic cGlnOnBpZw=='
    }
    if(token){
        // token
        config.headers['Authorization'] = 'Bearer '+token
    }
    // headers中配置serialize为true开启序列化
    if (config.method === 'post' && config.url.indexOf('auth2')>-1) {
        config.data = serialize(config.data)
        delete config.data.serialize
    }
    // console.log(config.params);
    deleteEmptyProperty(config.params);
    config.params = config.params || {}
    config.data=config.data||{}
    // config.params = Object.assign(
    //     {userId:'2222'},
    //     config.params || {}
    // )
    return config
}, error => {
    return Promise.reject(error)
})


// HTTPresponse拦截
axios.interceptors.response.use(res => {
    NProgress.done()
    const status = Number(res.status) || 200
    // console.log('message==='+JSON.stringify(res))
    let message = '网络错误'
    if(res.data && res.data.msg){
        message = res.data.msg
    }
    if (status === 401) {
        // store.dispatch('FedLogOut').then(() => {
        //   router.push({path: '/login'})
        // })
        return
    }
    if (status === 424) {
        Cookies.remove("shop_token")
        // router.push({path: '/login'})
        return
    }
    // console.log(status)
    // console.log(res.data.code)
    if (status == 200 && res.data.code === 20001) {
        router.push({path: '/info/index'});
        return;
    }
    if (status !== 200 || res.data.code === 1) {
        Message({
            message: message,
            type: 'error'
        })
        return Promise.reject(new Error(message))
    }
    return res.data
}, error => {
    NProgress.done()
    return Promise.reject(new Error(error))
})

export default axios
